import React from 'react';
import { getBankLogoUrl } from '../../../Accounts/Reconciliations/Options/getBankLogoUrl';
import { StyledTag } from './style';

export default function BankAccountTag({
    bankCode,
    accountNumber,
}) {
    return (
        <StyledTag>
            <img src={getBankLogoUrl(bankCode)} alt={accountNumber} className="logo-icon" />
            &nbsp;
            {accountNumber}
        </StyledTag>
    );
}
